import { getSelectors } from "./selectors.js";
import { splitTotalQuantityBetweenEyesides, isQuantityValid } from "../../../../utils/modules/EcommContent/ContactLensesEcommContent/context/utils/state-helpers.js";
const selectors = getSelectors();
const reducer = (state, action) => {
  switch (action.type) {
    case "setPurchaseType": {
      const { purchaseType } = action.payload;
      return {
        ...state,
        configurations: {
          ...state.configurations,
          purchaseType
        }
      };
    }
    case "setDeliveryInterval": {
      const { deliveryInterval } = action.payload;
      return {
        ...state,
        configurations: {
          ...state.configurations,
          subscriptionPurchaseConfigurations: {
            ...state.configurations.subscriptionPurchaseConfigurations,
            deliveryInterval
          }
        },
        configurator: {
          ...state.configurator,
          deliveryInterval: {
            showError: false
          }
        }
      };
    }
    case "setColumnCheckbox": {
      const { eyeSide, isEnabled } = action.payload;
      const newColumnUIState = {
        ...state.configurator[eyeSide],
        isEnabled
      };
      const newState = {
        ...state,
        configurator: {
          ...state.configurator,
          [eyeSide]: {
            ...newColumnUIState
          }
        }
      };
      return {
        ...newState,
        configurator: {
          ...newState.configurator,
          columns: {
            ...newState.configurator.columns
          },
          columnCheckboxes: {
            ...newState.configurator.columnCheckboxes,
            showError: false
            // Only show the checkbox error state on submit
          }
        }
      };
    }
    case "setPrescriptionAttribute": {
      const { eyeSide, attribute, value } = action.payload;
      return {
        ...state,
        configurations: {
          ...state.configurations,
          [eyeSide]: {
            ...state.configurations[eyeSide],
            prescription: {
              ...state.configurations[eyeSide].prescription,
              [attribute]: value
            }
          }
        }
      };
    }
    case "setRxToggleSelection": {
      const { rxToggle } = action.payload;
      return {
        ...state,
        configurations: {
          ...state.configurations,
          rxToggle
        }
      };
    }
    case "setSelectedQuantity": {
      const { eyeSide, quantity } = action.payload;
      return {
        ...state,
        configurations: {
          ...state.configurations,
          [eyeSide]: {
            ...state.configurations[eyeSide],
            quantity
          }
        }
      };
    }
    case "setTotalQuantity": {
      const { totalQuantity } = action.payload;
      const { bothQuantity, leftQuantity, rightQuantity } = splitTotalQuantityBetweenEyesides(state, totalQuantity);
      return {
        ...state,
        configurations: {
          ...state.configurations,
          left: {
            ...state.configurations.left,
            quantity: leftQuantity
          },
          right: {
            ...state.configurations.right,
            quantity: rightQuantity
          },
          both: {
            ...state.configurations.both,
            quantity: bothQuantity
          }
        }
      };
    }
    case "resetTotalQuantity": {
      const isBothEnabled = state.configurator.both.isEnabled;
      const isLeftEnabled = state.configurator.left.isEnabled;
      const isRightEnabled = state.configurator.right.isEnabled;
      const leftQuantity = isLeftEnabled ? 1 : state.configurations.left.quantity;
      const rightQuantity = isRightEnabled ? 1 : state.configurations.right.quantity;
      const bothQuantity = isBothEnabled ? 1 : state.configurations.both.quantity;
      return {
        ...state,
        configurations: {
          ...state.configurations,
          left: {
            ...state.configurations.left,
            quantity: leftQuantity
          },
          right: {
            ...state.configurations.right,
            quantity: rightQuantity
          },
          both: {
            ...state.configurations.both,
            quantity: bothQuantity
          }
        }
      };
    }
    case "resetFetchedSku": {
      const { eyeSide } = action.payload;
      return {
        ...state,
        queries: {
          ...state.queries,
          [eyeSide]: {
            ...state.queries[eyeSide],
            sku: void 0,
            error: void 0
          }
        }
      };
    }
    case "updateFetchedSku": {
      const { eyeSide, sku } = action.payload;
      return {
        ...state,
        queries: {
          ...state.queries,
          [eyeSide]: {
            ...state.queries[eyeSide],
            sku
          }
        }
      };
    }
    case "updateStockStatus": {
      const { eyeSide, stockIndicatorStatus, availableQuantity, allowBackOrder } = action.payload;
      return {
        ...state,
        configurator: {
          ...state.configurator,
          [eyeSide]: {
            ...state.configurator[eyeSide],
            stockIndicatorStatus,
            availableQuantity,
            allowBackOrder
          }
        }
      };
    }
    case "updateMaxSelectableQuantity": {
      const { eyeSide, maxSelectableQuantity } = action.payload;
      const { quantity } = state.configurations[eyeSide];
      const { selectionInvalidatedCount } = state.configurator[eyeSide].quantitySelector;
      const isQuantityValid$1 = isQuantityValid(quantity, maxSelectableQuantity);
      const productIsOutOfStock = maxSelectableQuantity === 0;
      let newQuantitySelection = quantity;
      let newSelectionInvalidatedCount = selectionInvalidatedCount;
      if (!isQuantityValid$1 && !productIsOutOfStock) {
        newQuantitySelection = maxSelectableQuantity;
        newSelectionInvalidatedCount = (selectionInvalidatedCount || 0) + 1;
      }
      return {
        ...state,
        configurations: {
          ...state.configurations,
          [eyeSide]: {
            ...state.configurations[eyeSide],
            quantity: newQuantitySelection
          }
        },
        configurator: {
          ...state.configurator,
          [eyeSide]: {
            ...state.configurator[eyeSide],
            quantitySelector: {
              ...state.configurator[eyeSide].quantitySelector,
              maxSelectableQuantity,
              selectionInvalidatedCount: newSelectionInvalidatedCount
            }
          }
        }
      };
    }
    case "triggerErrors": {
      const {
        invalidSubmissionsCount: previousCount,
        columns,
        columnCheckboxes,
        deliveryInterval
      } = state.configurator;
      const [isConfiguratorValid, configurator] = selectors.isConfiguratorValid(state);
      const newCount = (previousCount || 0) + 1;
      if (isConfiguratorValid) {
        return state;
      }
      return {
        ...state,
        configurator: {
          ...state.configurator,
          invalidSubmissionsCount: newCount,
          columns: {
            ...columns,
            showError: !configurator.areColumnsValid
          },
          columnCheckboxes: {
            ...columnCheckboxes,
            showError: !configurator.areColumnCheckboxesValid
          },
          deliveryInterval: {
            ...deliveryInterval,
            showError: configurator.isDeliveryIntervalValid === false
          }
        }
      };
    }
    case "resetErrors": {
      return {
        ...state,
        configurator: {
          ...state.configurator,
          invalidSubmissionsCount: void 0,
          columns: {
            ...state.configurator.columns,
            showError: false
          },
          columnCheckboxes: {
            ...state.configurator.columnCheckboxes,
            showError: false
          },
          deliveryInterval: {
            ...state.configurator.deliveryInterval,
            showError: false
          }
        }
      };
    }
    case "updateQueryError": {
      const { eyeSide, error } = action.payload;
      return {
        ...state,
        queries: {
          ...state.queries,
          [eyeSide]: {
            ...state.queries[eyeSide],
            error
          }
        }
      };
    }
    case "setQueryLoading": {
      const { eyeSide, loading } = action.payload;
      return {
        ...state,
        queries: {
          ...state.queries,
          [eyeSide]: {
            ...state.queries[eyeSide],
            loading
          }
        }
      };
    }
    default:
      return state;
  }
};
export {
  reducer
};
//# sourceMappingURL=reducer.js.map
